


















import Component from 'vue-class-component';

import { IspecialistDetail } from '@/store/specialist/index.d';
import {
  dispatchGetFollowedSpecialistLists,
  dispatchGetIMRecommendSpecialists,
  dispatchGetHospitalDeptSpecialists
} from '@/store/specialist';
import Webview from '@/webview';

@Component({
  name: 'FollowedSpecialist'
})
export default class FollowedSpecialist extends Webview {
  pageNo = 0;

  pageSize = 20;

  loading = false;

  specialists: IspecialistDetail[] = [];

  listFinished = false;

  hasFollowSpeicalist = false;

  async created() {
    await this.loadList();
    this.hasFollowSpeicalist = this.specialists.length > 0;
  }

  // eslint-disable-next-line class-methods-use-this
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 10);
    }, 0);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }

  async loadList() {
    const loadMap = {
      [this.constant.FOLLOWED_SPECIALIST]: this.fetchDoctors,
      [this.constant.RECOMMEND_SPECIALIST]: this.fetchRecommendDoctors,
      [this.constant.DEPARTMENT_SPECIALIST]: this.fetchHospitalDepartmentDoctors
    };

    const { name } = this.$route;
    await loadMap[name as keyof typeof loadMap]();
  }

  async fetchRecommendDoctors() {
    this.registFunc({
      type: 'recommendDoctors',
      func: this.fetchRecommendDoctors
    });
    const consultId = parseInt(this.$route.query.consultId as string, 0);
    if (!consultId) return;
    const { doctorList } = await dispatchGetIMRecommendSpecialists(this.$store, {
      consultId,
      areaName: this.location
    });
    this.listFinished = true;
    this.specialists.push(...doctorList);
  }

  async fetchDoctors() {
    this.registFunc({
      type: 'followList',
      func: this.fetchDoctors
    });
    this.loading = true;
    const { doctors, total } = await dispatchGetFollowedSpecialistLists(this.$store, {
      pageNo: this.pageNo += 1,
      pageSize: this.pageSize,
      areaName: this.location
    });

    this.specialists.push(...doctors);
    this.listFinished = this.specialists.length >= total;
    this.loading = false;
  }

  async fetchHospitalDepartmentDoctors() {
    this.loading = true;
    const { hospitalId, departmentId, departmentType, departmentName } = this.$route.query;
    this.adapter.setTitle(departmentName as string);
    const { count = 0, data } = await dispatchGetHospitalDeptSpecialists(this.$store, {
      hospitalId: Number(hospitalId),
      departmentId: Number(departmentId),
      departmentType: Number(departmentType),
      pageNo: this.pageNo += 1,
      pageSize: this.pageSize
    });

    this.specialists.push(...data);

    this.listFinished = this.specialists.length >= count;

    this.loading = false;
  }

  goSpeicalist() {
    this.$router.push(this.constant.SPECIALIST_CLINIC);
  }
}
